var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/app/index/templates/project.html',
    '<ul>\n' +
    '    <li ng-repeat="item in items track by item.id" class="slide-items">\n' +
    '        <a href="{{ item.url }}" class="mosaic__item mosaic__item_two">\n' +
    '            <div class="mosaic__img">\n' +
    '                <div class="page-top__filter"></div>\n' +
    '                <img src="{{ item.background_image.thumb_path }}" alt="{{ item.name }}">\n' +
    '            </div>\n' +
    '            <div class="mosaic__text">\n' +
    '                <h3>{{ item.name }}</h3>\n' +
    '            </div>\n' +
    '        </a>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '<button class="arrow-left arrows ng-hide" ng-click="prev()" ng-show="items.length > 2"></button>\n' +
    '<button class="arrow-right arrows right-ar ng-hide" ng-click="next()" ng-show="items.length > 2"></button>\n' +
    '');
}]);

module.exports = "/app/index/templates/project.html";